import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {ConfirmModalService} from '../../../../_shared/_components/confirm-modal/confirm-modal.component';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {CustomerService} from '../../../../_services/configuration-services';

@Component({
    selector: 'app-customer-delete-confirmation-modal',
    templateUrl: './customer-delete-confirmation-modal.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CustomerDeleteConfirmationModalComponent implements OnInit {

    public customerId: string;

    reasons: number[] = [];
    loading: boolean = false;


    constructor(
        private readonly customerService: CustomerService,
        public readonly activeModal: NgbActiveModal) {
    }

    ngOnInit(): void {
        this.loading = true;
        this.customerService.getCustomerNotDeletableReasons(this.customerId).pipe().subscribe(result => {
            this.reasons = result;
            this.loading = false;
        })
    }

    close(): void {
        this.activeModal.close(ConfirmModalService.no);
    }

    yes(): void {
        this.activeModal.close(ConfirmModalService.yes);
    }

    no(): void {
        this.activeModal.close(ConfirmModalService.no);
    }

}
